/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRegularSkillsRequest
 */
export interface UpdateRegularSkillsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRegularSkillsRequest
     */
    globalTopSkills: Array<string>;
}

/**
 * Check if a given object implements the UpdateRegularSkillsRequest interface.
 */
export function instanceOfUpdateRegularSkillsRequest(value: object): value is UpdateRegularSkillsRequest {
    if (!('globalTopSkills' in value) || value['globalTopSkills'] === undefined) return false;
    return true;
}

export function UpdateRegularSkillsRequestFromJSON(json: any): UpdateRegularSkillsRequest {
    return UpdateRegularSkillsRequestFromJSONTyped(json, false);
}

export function UpdateRegularSkillsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRegularSkillsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'globalTopSkills': json['globalTopSkills'],
    };
}

export function UpdateRegularSkillsRequestToJSON(value?: UpdateRegularSkillsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'globalTopSkills': value['globalTopSkills'],
    };
}

